export default "__VITE_ASSET__CPl8Z1jH__"